import type { PersonStats } from '~/types/person/person';

/**
 * What one removal request and one scan would have cost the person to do by
 * hand, in minutes. The same weights the API applies to its own lifetime
 * counts, so the card and the wire never disagree.
 */
export const TIME_SAVED_MINUTES = {
    perScan: 5,
    perRemovalRequest: 42,
} as const;

/**
 * The one client formula for "Time Saved". Every surface that shows the number
 * derives it here from the person's lifetime counts — never from a second
 * arithmetic of its own.
 */
export const timeSavedMinutes = (stats: PersonStats | null | undefined): number => {
    if (!stats) return 0;

    return stats.removals_requested * TIME_SAVED_MINUTES.perRemovalRequest
        + stats.scans * TIME_SAVED_MINUTES.perScan;
};
